import { Environment } from 'src/types';

export const graphqlConfig = {
  [Environment.Production]: { url: '/graphql' },
  [Environment.Staging]: { url: '/graphql' },
  [Environment.Development]: { url: 'http://localhost:4000/graphql' },
} as const;
